module.exports = __webpack_public_path__ + "img/p15.20a8092e.png";